<template>
  <!-- На узких экранах (≤ --bp-md) таблица отображается карточками; для подписи ячеек задайте на td атрибут data-label -->
  <div class="ui-table">
    <table>
      <slot />
    </table>
  </div>
</template>

<style scoped>
.ui-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

:slotted(th),
:slotted(td) {
  text-align: left;
  padding: 10px;
  border-bottom: 1px solid #e2e8f0;
}

/* На узких экранах - карточки. Для подписи ячейки нужен data-label на td. */
@media (max-width: 960px) {
  :slotted(thead) {
    display: none;
  }

  :slotted(tbody tr) {
    display: block;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 12px;
    background: #fff;
  }

  :slotted(tbody tr:last-child) {
    margin-bottom: 0;
  }

  :slotted(tbody td) {
    display: block;
    padding: 6px 0;
    border-bottom: none;
  }

  /* Итоговая строка: подпись слева, значение справа, без подписи ячеек */
  :slotted(tfoot tr) {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
  }

  :slotted(tfoot td) {
    display: block;
    padding: 0;
    border-bottom: none;
  }

  :slotted(tbody td)::before {
    content: attr(data-label);
    font-weight: 600;
    display: inline-block;
    min-width: 100px;
    margin-right: 8px;
  }
}
</style>
